
import barba from '@barba/core';
import Swiper, { Navigation, Pagination, Scrollbar, Autoplay,EffectCreative } from 'swiper';
// configure Swiper to use modules
Swiper.use([Navigation, Pagination,Scrollbar, Autoplay,EffectCreative]);

export default class{

	constructor(){

        barba.hooks.beforeOnce((data) => {
            this.bloglistSlider(data.next.container)
            this.worksSlider(data.next.container)
            this.onedaySlider(data.next.container)
            this.blogSlider(data.next.container)
            // this.eventSlider()

        })
        barba.hooks.after((data) => {
            this.bloglistSlider(data.next.container)
            this.worksSlider(data.next.container)
            this.onedaySlider(data.next.container)
            this.blogSlider(data.next.container)

            // this.eventSlider()
        });
        
    }
    
    // heroSlider(){
        
    // }
    
    
    worksSlider(container){
        const works = new Swiper('.js-works-slider', {
            speed:1000,
            slidesPerView: 'auto',
            spaceBetween: 20,
            simulateTouch:true,
            centeredSlides: false,
            breakpoints: {
                
                576: {
                    slidesPerView: 'auto',
                    spaceBetween:  40,
                }
            },
            scrollbar: { 
                el: '.js-works-slider .swiper-scrollbar',
                draggable: true,
            },
        })
    }
     blogSlider(container){
        this.blog_thumbnails = container.querySelectorAll('[data-blog-slider-thumbnails] button');
        const slider = new Swiper('[data-blog-slider]', {
            speed:1000,
            easing:"linear",
            spaceBetween: 10,
            simulateTouch:true,
            centeredSlides: true,
            slidesPerView: "auto",
            navigation: {
                nextEl: '[data-blog-slider] .swiper-button-next',
                prevEl: '[data-blog-slider] .swiper-button-prev',
            },
            breakpoints: {
                
                576: {
                    spaceBetween:  40,
                },
                991: {
                    spaceBetween:  50,
                }
            },
            on: {
                init :()=> {
                    if(this.blog_thumbnails.length > 0){
                        this.blog_thumbnails[0].classList.add('-active')
                    }
                },
                slideChange:()=> {
                    if(this.blog_thumbnails.length > 0){
                        const active_button = document.querySelector('[data-blog-slider-thumbnails] button.-active');
                        if(active_button){
                            active_button.classList.remove('-active')
                        }
                        this.blog_thumbnails[slider.activeIndex].classList.add('-active')
                    }
                },
            }
        });
        
        if(this.blog_thumbnails.length > 0){
            const blogThumbnailAddEvent = (el,i) => {
                el.addEventListener('click',function(e){
                    e.preventDefault();
                    slider.slideTo(i);
                })
            }

            for(var i = 0; i < this.blog_thumbnails.length; i++){
                blogThumbnailAddEvent( this.blog_thumbnails[i],i);
            }
        }
    }
    onedaySlider(container){
        const counter = container.querySelector("[data-oneday-slider] .swiper-button-counter")
        const navigator = container.querySelector("[data-oneday-slider] .swiper-button-navigator")
        const prev = container.querySelector("[data-oneday-slider] .swiper-nav-prev")
        const next = container.querySelector("[data-oneday-slider] .swiper-nav-next")
        const slider = new Swiper('[data-oneday-slider]', {
            speed:1000,
            spaceBetween: 20,
            simulateTouch:true,
            slidesPerView: "auto",
            centeredSlides: true,
            keyboard: {
                enabled: true,
                onlyInViewport: false,
              },
            navigation: {
                nextEl: '[data-oneday-slider] .swiper-button-next',
                prevEl: '[data-oneday-slider] .swiper-button-prev',
            },
            breakpoints: {
                
                992: {
                    slidesPerView:"auto",
                    spaceBetween:  20,
                },
                1200: {
                    slidesPerView:"auto",
                    spaceBetween:  40,
                }
            },
            autoplay:{
                delay:4000,
                disableOnInteraction:false,
                stopOnLastSlide:false
            },
            on:{
                
                slideChange :() => {
                    if(counter){
                        counter.innerText = (slider.realIndex + 1) + ' / ' + slider.slides.length
                    }
                    if(navigator){
                        navigator.setAttribute('data-step',(slider.realIndex + 1))
                    }
                    // if (slider.isEnd) {
                    //     slider.slideTo(0);
                    //   } else {
                    //     slider.slideTo(slider.realIndex + 1);
                    // }
                }
            }
        })
        if(prev){
            prev.addEventListener('click',()=>{
                 if (slider.isBeginning) {
                    slider.slideTo(slider.slides.length);
                    } else {
                    slider.slideTo(slider.realIndex - 1);
                }
            })
        }
        if(next){
            next.addEventListener('click',()=>{
                 if (slider.isEnd) {
                    slider.slideTo(0);
                    } else {
                    slider.slideTo(slider.realIndex + 1);
                }
            })
        }
    }
    bloglistSlider(container){
        const bloglist = new Swiper('.js-bloglist-slider', {
            speed:1000,
            slidesPerView: 'auto',
            spaceBetween: 20,
            simulateTouch:true,
            breakpoints: {
                
                576: {
                    slidesPerView: 'auto',
                    spaceBetween:  40,
                }
            },
            scrollbar: { 
                el: '.js-bloglist-slider .swiper-scrollbar',
                draggable: true,
            },
        })
    }
    
}